import { useLocation, useNavigate } from "react-router-dom";
import { useAtomValue } from "jotai";

import { ExtendedGlobalApp } from "../../Cards/AppCard";
import PopoverDropdownMenu from "../../../Menus/PopoverDropdownMenu";
import DropdownOptionWithIcon from "../../../Menus/DropdownOptionWithIcon";
import useInstallGlobalApp from "../../../../api/api-hooks/globalApps/useInstallGlobalApp";
import { workspaceIdAtom } from "../../../../atoms/WorkspaceAtoms";
import { AppConfirm } from "../../../../utils/PopupUtil";
import useUninstallGlobalApp from "../../../../api/api-hooks/globalApps/useUninstallGlobalApp";

const AppOptions = ({
  app,
  viewInMarketplace,
}: {
  app: ExtendedGlobalApp;
  viewInMarketplace?: boolean;
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { installGlobalApp, installID } = useInstallGlobalApp();
  const { uninstallGlobalApp, uninstallingApp } = useUninstallGlobalApp();
  const workspaceID = useAtomValue(workspaceIdAtom);

  const uninstallApp = async () => {
    const result = await AppConfirm({
      title: `Uninstall ${app.Name}?`,
      html: "Are you sure you want to uninstall this app? <br/> It will be removed from ALL workspaces in this cloud!",
      confirmButtonText: "Uninstall",
    });

    if (!result.isConfirmed) return;

    const result2 = await AppConfirm({
      title: "Final Warning",
      text: "All data sources and records associated with this app will be lost. This action cannot be undone.",
      confirmButtonText: "Uninstall",
    });

    if (!result2.isConfirmed) return;

    uninstallGlobalApp({
      globalAppID: app?.id,
      deleteEverything: true,
    });
  };

  const loading = installID === app.id || uninstallingApp;

  return (
    <PopoverDropdownMenu>
      {!!viewInMarketplace && (
        <DropdownOptionWithIcon
          name="View in Marketplace"
          onClick={() =>
            navigate(`${pathname}?store=true&page=installed-apps&app=${app.id}`)
          }
          icon="mdi mdi-shopping"
        />
      )}
      {app.isOutdated && (
        <DropdownOptionWithIcon
          name="Update App"
          onClick={() => {
            installGlobalApp({
              payload: {
                globalAppID: app.id,
                workspaceID: workspaceID as string,
              },
            });
          }}
          icon="mdi mdi-update"
          disabled={loading}
        />
      )}
      <DropdownOptionWithIcon
        name="Remove from Cloud"
        onClick={() => uninstallApp()}
        icon="mdi mdi-delete"
        disabled={loading}
      />
    </PopoverDropdownMenu>
  );
};

export default AppOptions;
